var render, staticRenderFns
import script from "./MixinTranslation.vue?vue&type=script&lang=js"
export * from "./MixinTranslation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d33ed58",
  null
  
)

export default component.exports